function addHTMLtoDescription(
  header,
  firstText,
  secondText,
  thirdText,
  linkText,
  link
) {
  return (
    '<div id="content">' +
    '<div id="siteNotice">' +
    "</div>" +
    `<h6 id="firstHeading" class="firstHeading">${header}</h6>` +
    '<div id="bodyContent">' +
    `<p>${firstText}</p>` +
    `<p>${secondText}</p>` +
    `<p>${thirdText}</p>` +
    '<a href="' +
    `${link}` +
    '" target="_blank" rel="noopener noreferrer">' +
    `${linkText}</a> ` +
    "</div>" +
    "</div>"
  );
}

let location = {
  addFinalData() {
    if (this.locationFinalData.length > 1) return;
    locationData.forEach(element => {
      let place = {};
      place.description = addHTMLtoDescription(
        element.header,
        element.firstText,
        element.secondText,
        element.thirdText,
        element.linkText,
        element.link
      );
      place.coordinates = element.coordinates;
      this.locationFinalData.push(place);
    });
  },
  locationFinalData: []
};

export default location;

const locationData = [
  {
    header: "Świat Podłóg",
    firstText: "Zielony Targówek Salon C.H., ",
    secondText: "Warszawa, ul. Głębocka 13",
    thirdText: "kom. 507 086 004",
    linkText: "",
    link: "",
    coordinates: { lat: 52.300562, lng: 21.057206 }
  },
  {
    header: "Dom Dębu",
    firstText: "Zakładowa 20 Wrocław",
    secondText: "Tel. 722 100 913",
    thirdText: "Tel. 725 075 423",
    linkText: "www.mad-podlogi.pl/",
    link: "http://www.mad-podlogi.pl/",
    coordinates: { lat: 51.13089, lng: 17.04406 }
  },
  {
    header: "MAD Dawid Maćkowiak",
    firstText: "Załęcze 28, Rawicz",
    secondText: "Tel. 48 725 075 423",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 51.598248, lng: 16.800699 }
  },
  {
    header: "Salon Drzwi Podłogi A. Fiałkowicz",
    firstText: "Gronowa 79, Poznań, Polska",
    secondText: "Tel. 48 733 355 371",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 52.43013, lng: 16.93352 }
  },
  {
    header: "MBS Home",
    firstText: "Głogowska 227 Poznań",
    secondText: "tel. 792 414 415",
    thirdText: "tel .881 389 993",
    linkText: "www.facebook.com/MBSHome.eu/",
    link: "http://www.facebook.com/MBSHome.eu/",
    coordinates: { lat: 52.377775, lng: 16.875813 }
  },
  {
    header: "Pracownia Drewna",
    firstText: "Galeria Arkada",
    secondText: "Obornicka 229, 60-650 Poznań",
    thirdText: "Tel. 572 547 480",
    linkText: "",
    link: "",
    coordinates: { lat: 52.445978, lng: 16.907000 }
  },

  {
    header: "Parkiety Kosiński",
    firstText: "Trybuny Ludów 31, Kraków, Polska",
    secondText: "Tel. 48 501 577 988",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 50.018102, lng: 19.963088 }
  },
  {
    header: "Archinova",
    firstText: "Aleksandra Nowak, ul. Spacerowa 3 lok. 35",
    secondText: "95-100 Zgierz, łódzkie",
    thirdText: "Tel. 502 691 982",
    linkText: "",
    link: "",
    coordinates: { lat: 51.854049, lng: 19.426915 }
  },
  {
    header: "Hoton Design",
    firstText: "Jagiellońska 70, Bydgoszcz",
    secondText: "Tel. 602 731 177",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 53.122133, lng: 18.023722 }
  },
  {
    header: "Nowoczesna Stolarka Wawruk",
    firstText: "Białystok, ul. Wschodnia 4",
    secondText: "tel. 85 675 65 00",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 53.149373, lng: 23.187398 }
  },

  {
    header: "Świat Podłóg",
    firstText: "Warszawa, Aleje Jerozolimskie 185, salon nr 6",
    secondText: "Aleje Jerozolimskie 185, salon nr 6",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 52.209482, lng: 20.950997 }
  },
  {
    header: "Świat Podłóg",
    firstText: "Warszawa, Bartycka 26, Pawilon 44",
    secondText: "Tel. 48 572 662 286",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 52.214441, lng: 21.054589 }
  },
  {
    header: "Świat Podłóg",
    firstText: "Domosfera salon nr 14",
    secondText: "Warszawa, Domaniewska 37B",
    thirdText: "510 254 922",
    linkText: "",
    link: "",
    coordinates: { lat: 52.1819, lng: 21.00677 }
  },
  {
    header: "Galeria Podłóg",
    firstText: "Warszawa, Bartycka 24, Pawilon 204",
    secondText: "Tel. 48 500 113 173",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 52.213451, lng: 21.057461 }
  },
  {
    header: "Świat Podłóg",
    firstText: "Warszawa, Bartycka 26, Pawilon 851",
    secondText: "Tel. 48 797 701 777",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 52.213434, lng: 21.053422 }
  },
  {
    header: "Euro Parkiet",
    firstText: "Warszawa, Bartycka 24/26, Pawilon 226",
    secondText: "Tel. 48 502 389 081",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 52.213456, lng: 21.057451 }
  },
  {
    header: "Świat Podłóg",
    firstText: "Warszawa, Bartycka 24/26, Pawilon 105",
    secondText: "Tel. 48 502 389 086",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 52.214441, lng: 21.057997 }
  },

  {
    header: "RoyalWood Hubert Król",
    firstText: "Majora Władysława Raginisa 13/1, 71-899 Szczecin",
    secondText: "Tel. 507 043 886",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 53.438813, lng: 14.562556 }
  },
  {
    header: "Krezus Podłogi",
    firstText: "Klonowa 55/J, 25-001 Kielce",
    secondText: "Tel. 41 344 56 01",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 50.890722, lng: 20.636264 }
  },
  {
    header: "Boden Podłogi",
    firstText: "Nałęczowska 30, 20-701 Lublin",
    secondText: "Tel. 81 444 61 00",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 51.250312, lng: 22.510765 }
  },
  {
    header: "This Is Wood",
    firstText: "aleja Grunwaldzka 211, 80-266 Gdańsk",
    secondText: "Tel. 503 831 960",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 54.388548, lng: 18.590469 }
  },
  {
    header: "Top Home",
    firstText: "Żurawia 14B, 78-100 Kołobrzeg",
    secondText: "Tel. 94 300 50 24",
    thirdText: "",
    linkText: "",
    link: "",
    coordinates: { lat: 54.16582, lng: 15.55191 }
  },
  {
    header: "Krezus Podłogi",
    firstText: "Żagańska 94/3, Kielce",
    secondText: "Plaza Park Kielce",
    thirdText: "Tel. 48 509 156 135",
    linkText: "",
    link: "",
    coordinates: { lat: 50.88689, lng: 20.629479 }
  },
  {
    header: "Świat Podłóg Mobilny Doradca Klienta",
    firstText: "Łukasz Kujawski",
    secondText: "Gdańsk, Gdynia, Sopot",
    thirdText: "Tel. 506 339 095",
    linkText: "swiatpodlog.gdansk@gmail.com",
    link: "",
    coordinates: { lat: 54.441205, lng: 18.562791 }
  }
];
